import { useTranslation } from 'react-i18next';
import { Globe } from 'lucide-react';

export function LanguageSwitcher() {
  const { i18n } = useTranslation();

  const changeLanguage = (lng: string) => {
    i18n.changeLanguage(lng);
  };

  return (
    <div className="flex items-center gap-2">
      <Globe className="h-4 w-4 text-gray-500" />
      <select
        value={i18n.language}
        onChange={(e) => changeLanguage(e.target.value)}
        className="bg-transparent text-sm border border-gray-300 rounded px-2 py-1 focus:outline-none focus:ring-2 focus:ring-litla-primary"
      >
        <option value="is">Íslenska</option>
        <option value="en">English</option>
      </select>
    </div>
  );
}
